import { Flex, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { BsSearch } from 'react-icons/bs';

export default function SearchFilterInput({
    source,
    onSearch,
    showFilter = false,
    FilterButton,
    handleFilter,
}) {
    return (
        <Flex my="0" justifyContent="space-between">
            <Flex width={'100%'} marginRight={showFilter ? '8px' : ''}>
                <InputGroup>
                    <InputLeftElement color="gray.500" pointerEvents="none">
                        <BsSearch />
                    </InputLeftElement>
                    <Input
                        placeholder={`Search ${source}`}
                        borderRadius={'50px'}
                        onChange={(e) => onSearch(e.target.value)}
                        type="text"
                        inputMode="text"
                    />
                </InputGroup>
            </Flex>
            {showFilter && FilterButton ? <FilterButton handleFilter={handleFilter} /> : null}
        </Flex>
    );
}
